<template>
  <div
    v-if="clientContext.isTrial"
    class="trial-banner"
    role="status"
  >
    <span class="trial-banner__label">{{ t("trialBanner.label") }}</span>

    <p class="trial-banner__text">{{ t("trialBanner.lead") }}</p>

    <button
      type="button"
      class="trial-banner__action"
      @click="onConnectSuppliers"
    >
      {{ t("trialBanner.action") }}
    </button>
  </div>
</template>

<script setup lang="ts">
/**
 * Постоянная плашка демо-доступа (CAB-567).
 *
 * Именно плашка, а не модалка: человек в демо-доступе проводит в кабинете не один
 * сеанс, и всплывающее окно на каждый вход стало бы раздражителем, который учатся
 * закрывать не читая.
 *
 * Слово «демо-доступ» выбрано намеренно и не совпадает с «режимом демонстрации» —
 * тот скрывает цены и названия поставщиков для показа на экране. Два состояния с
 * одним словом сделали бы обращения в поддержку неразрешимыми.
 *
 * Текст один на всех: отдельной фразы «демо-поставщики не настроены» здесь больше
 * нет. Она выбиралась по demo_client_id из связки, а этого поля у клиента без
 * партнёра в связке нет вовсе — демо-набор ему достаётся с аккаунта Eplex и
 * прекрасно работает. Плашка уверенно сообщала обратное человеку, который видел
 * на экране результаты поиска по демо-поставщикам (CAB-561, замечание 3).
 */
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useClientContextStore } from "../../../store/eplex/eplexClientContext";

const SUPPLIERS_SETTINGS_PATH = "/app/eplex/function-settings";

const { t } = useI18n();
const router = useRouter();
const clientContext = useClientContextStore();

/**
 * Ведём в раздел настроек поставщиков — там стоят кнопки перехода в рабочий режим
 * (CAB-568). Сам переход отсюда не запускаем: решение необратимо, и подтверждать
 * его человек должен там, где видит, что именно у него настроено.
 */
function onConnectSuppliers(): void {
  router.push(SUPPLIERS_SETTINGS_PATH);
}
</script>
